import React from 'react';

import { StringKeyValue } from '../actions/types';
import ErrorMessage from '../components/Messages/ErrorMessage';
import { ErrorReducer } from '../reducers/error';
import { errorNames, serviceError } from '../util/mappings/errorName';

interface Props {
    text: StringKeyValue;
    error: ErrorReducer;
}

const AppErrors = ({ text, error }: Props): JSX.Element => {
    const { errorMessage } = error;

    let title;
    let content;
    let link;
    let linkText;
    let infoBox;

    switch (errorMessage) {
        case errorNames.customerIsDNumber:
            title = text.customerDNumberTitle;
            content = [text.customerDNumberText];
            link = text.customerDNumberLink;
            linkText = text.customerDNumberLinkText;
            infoBox = text.customerDNumberInfoBox;
            break;
        case errorNames.customerIsMinor:
            title = text.mindreaarigKundeHeader;
            content = [text.mindreaarigKundeText];
            break;

        case serviceError:
            title = text.serviceErrorTitle;
            content = [text.serviceErrorText1, text.serviceErrorText2];
            link = text.serviceErrorLink;
            linkText = text.serviceErrorLinkText;
            infoBox = text.serviceErrorInfoBox;
            break;

        case errorNames.priceError:
            title = text.priceLookupErrorTitle;
            content = [text.priceLookupErrorText1];
            link = text.priceLookupErrorLink;
            linkText = text.priceLookupErrorLinkText;
            infoBox = text.priceLookupErrorInfoBox;
            break;

        case errorNames.customerIsMissingAddress:
            title = text.customerMissingAddressTitle;
            content = [text.customerMissingAddressText1];
            link = text.customerMissingAddressLink;
            linkText = text.customerMissingAddressLinkText;
            infoBox = text.customerMissingAddressInfoBox;
            break;

        case errorNames.kycBlocked:
            title = text.receiptControlTitle;
            content = [text.receiptControlP2, text.receiptControlP3];
            link = text.receiptControlButtonLink;
            linkText = text.receiptControlButtonText;
            infoBox = text.receiptControlInfoBox;
            break;

        case errorNames.otherApplicantMissingData:
            title = text.receiptOtherPersonTitle;
            content = [text.receiptOtherPersonP1, text.receiptOtherPersonP2];
            link = text.receiptOtherPersonButtonLink;
            linkText = text.receiptOtherPersonButtonText;
            infoBox = text.receiptOtherPersonInfoBox;
            break;

        case errorNames.sblSaveError:
        case errorNames.incorrectNewCase:
            title = text.receiptSblFailedTitle;
            content = [text.receiptSblFailedP1, text.receiptSblFailedP2];
            link = text.receiptSblFailedButtonLink;
            linkText = text.receiptSblFailedButtonText;
            infoBox = text.receiptSblFailedInfoBox;
            break;

        case errorNames.customerIsMissingBisnode:
            title = text.customerMissingInBisnodeTitle;
            content = [text.customerMissingInBisnodeText];
            link = text.customerMissingInBisnodeLink;
            linkText = text.customerMissingInBisnodeLinkText;
            infoBox = text.customerMissingInBisnodeInfoBox;
            break;

        case errorNames.upgradeToVehicleLoanFailed:
            title = text.upgradeLoanErrorTitle;
            content = [text.upgradeLoanErrorText1];
            link = text.upgradeLoanErrorLink;
            linkText = text.upgradeLoanErrorLinkText;
            infoBox = text.upgradeLoanErrorInfoBox;
            break;

        default:
            title = text.genericErrorTitle;
            content = [text.genericErrorText1, text.genericErrorText2, text.genericErrorText3];
            link = text.genericErrorLink;
            linkText = text.genericErrorLinkText;
            infoBox = text.genericErrorInfoBox;
    }

    return <ErrorMessage title={title} textList={content} link={link} linkText={linkText} infoBox={infoBox} />;
};

export default AppErrors;
